export const menus = [
   {
    id: 200,
    title: '경영정보',
    link: 'mnginfo',
    icon: 'statistics',
    expand: true,
    checked: true,
    items: [
      { id: 201, title: '사업목표', link: 'goal_statics', checked: true },
      { id: 202, title: '사업목표상세', link: 'goal_statics/detail', admin: true, checked: true },
      { id: 203, title: '사업목표vs수주실적', link: 'obtainorder_statics', checked: true },
      { id: 204, title: '사업목표vs매출실적', link: 'salesresults_statics' , checked: true },
      { id: 205, title: '사업목표vs이익실적', link: 'profitresults_statics' , checked: true },
      {
        id: 206,
        title: '판관비사용실적',
        link: 'sales-mng-cost-stats-view-new',        
        checked: true,
      },
      { id: 207, title: '예산vs집행실적', link: 'budgettoactual' , checked: false },
    ],
  },
  {
    id: 2,
    title: '목표관리',
    link: 'goalsetting',
    icon: 'goal',
    expand: true,
    checked: true,
    items: [
      { id: 21, title: '영업목표등록', link: 'goalsetting', checked: false },
    ],
  },
  {
    id: 500,
    title: '영업활동관리',
    link: 'salesActivity',
    icon: 'partner',
    expand: true,
    checked: true,
    items: [
      { id: 501, title: '영업일정등록', link: 'salesActivity', checked: true },
      { id: 502, title: '영업활동등록', link: 'salesAction', checked: true },
      { id: 503, title: '영업활동현황', link: 'salesActionStat', checked: true },
      { id: 504, title: '휴일관리', link: 'HolidayMng', checked: true },
    ],
  },
  {
    id: 3,
    title: '포캐스팅 관리',
    link: 'chancemng',
    icon: 'project',
    expand: true,
    checked: true,
    items: [
      { id: 31, title: `포캐스팅 등록 현황`, link: 'chancemng', checked: true },
      {
        id: 32,
        title: `수주 실패`,
        link: 'chance-fail',
        checked: true,
      },
      { id: 33, title: '부서별 통계', link: 'forecaststat', checked: true },
      {
        id: 34,
        title: '중요도별 통계',
        link: 'forecastmonthstat',
        checked: true,
      },
      {
        id: 35,
        title: '포캐스팅 등록 건수',
        link: 'project_dept_count',
        checked: true,
      },
      {
        id: 36,
        title: '매출 견적서 현황',
        link: 'sales_estimate',
        checked: true,
      },
      {
        id: 37,
        title: '매입 견적서 현황',
        link: 'buys_estimate',
        checked: true,
      },
    ],
  },
  {
    id: 4,
    title: '수주 관리',
    link: 'projectmng',
    icon: 'order',
    expand: true,
    checked: true,
    items: [
      { id: 41, title: '프로젝트 관리', link: 'projectmng', checked: true },
      { id: 42, title: '유지보수 관리', link: 'maintancetmng', checked: true },      
      { id: 47, title: '기타매출 관리', link: 'etcmng', checked: true },
      {
        id: 43,
        title: '수주품의서 관리',
        link: 'project_orders',
        checked: true,
      },
      
      // {
      //   id: 44,
      //   title: '프로젝트 통계',
      //   link: 'project_dept_stat',
      //   checked: true,
      // },
      // {
      //   id: 45,
      //   title: '유지보수 통계',
      //   link: 'maintance_dept_stat',
      //   checked: true,
      // },
      {
        id: 48,
        title: 'MA 매출 계산서 발행',
        link: 'invoice_maintenance',
        checked: true,
      },
       {
        id: 49,
        title: 'MA 매입 계산서 접수',
        link: 'purchase_maintenance',
        checked: true,
      },
      {
        id: 45,
        title: '매출 발주서 현황',
        link: 'sales_order_sheet',
        checked: true,
      },
      {
        id: 46,
        title: '매입 발주서 현황',
        link: 'buys_order_sheet',
        checked: true,
      },
    ],
  },
  {
    id: 12,
    title: '거래처/제품 관리',
    link: 'partnermng',
    icon: 'partner',
    expand: true,
    checked: true,
    items: [
      { id: 121, title: '거래처 관리', link: 'partnermng', checked: true },
      { id: 122, title: '제품&상품 관리', link: 'productmng', checked: true },
      //      { id: 92, title: '카드관리(미구현)', link: '', checked: true },
      //      { id: 93, title: '마감관리(미구현)', link: '', checked: true },
    ],
  },
  {
    id: 5,
    title: '세금계산서 관리',
    link: 'paymentmng',
    icon: 'sales',
    expand: true,
    checked: true,
    items: [
      {
        id: 51,
        title: '매출매입 세금계산서',
        link: 'taxbillmng',
        checked: true,
      },
      {
        id: 52,
        title: '세금계산서 통계',
        link: 'taxbill_statics',
        checked: true,
      },
    ],
  },
  {
    id: 6,
    title: '채권/채무 관리',
    link: '',
    icon: 'bond',
    expand: true,
    checked: true,
    items: [
      { id: 61, title: '채권/채무 관리', link: 'bonds-depts', checked: true },
      { id: 62, title: '수금/지급 완료', link: 'collects-buys', checked: true },

      {
        id: 63,
        title: '채권/채무 통계 ',
        link: 'bonds-depts-statics',
        checked: true,
      },
      {
        id: 64,
        title: '수금/지급통계',
        link: 'collects-buys-statics',
        checked: true,
      },
    ],
  },
  // {
  //   id: 7,
  //   title: '기술지원',
  //   link: 'techmng',
  //   icon: 'tech',
  //   expand: true,
  //   checked: true,
  //   items: [
  //     { id: 71, title: '기술지원관리', link: 'techmng', checked: true },
  //     { id: 72, title: '작업지원요청관리', link: 'reqtechmng', checked: true },
  //     { id: 73, title: '작업지원계획관리', link: 'plantechmng', checked: true },
  //     { id: 74, title: '작업지원결과관리', link: 'rslttechmng', checked: true },
  //   ],
  // },

  {
    id: 8,
    title: '결산관리',
    icon: 'eis',
    expand: true,
    checked: true,
    admin: true,
    items: [
      { id: 81, title: '조직별', link: 'groups-accounts', checked: true },
      { id: 82, title: '계산서별 실적', link: 'bills-accounts', checked: true },
      {
        id: 83,
        title: 'TOP50 업체별',
        link: 'top50-company-accounts',
        checked: true,
      },
      { id: 84, title: '월별 결산', link: 'months-accounts', checked: true },
      { id: 85, title: '예상 실적', link: 'forecast-results', checked: true },

      { id: 86, title: '영업통계', link: 'sales-statics', checked: true },
      {
        id: 87,
        title: '영업사원별 통계',
        link: 'salesman-statics',
        checked: true,
      },
      // {
      //   id: 88,
      //   title: '계정별 판매관리비 통계',
      //   link: 'account-sales-manage-statics',
      //   checked: true,
      // },

      // {
      //   id: 89,
      //   title: '매출처별 통계',
      //   link: 'vendor_dept_stat',
      //   checked: true,
      // },
    ],
  },
  /*
  {
    id: 9,
    title: '판관비 관리',
    icon: 'cost',
    expand: true,
    checked: true,
    items: [
      // {
      //   id: 91,
      //   title: '판매관리비 통계(2024.07.13)',
      //   link: 'sales-manage-statics',
      //   checked: true,
      // },
      // {
      //   id: 91,
      //   title: '판매관리비 통계',
      //   link: 'sales-mng-cost-stats',
      //   checked: true,
      // },
      // {
      //   id: 92,
      //   title: '전체 공통비 통계',
      //   link: 'common-cost-stats',
      //   checked: true,
      // },
      // {
      //   id: 85,
      //   title: '전체 공통비 통계',
      //   link: 'total-common-cost-statics',
      //   checked: true,
      // },
      // {
      //   id: 93,
      //   title: '판매관리비 관리',
      //   link: 'sales-cost-manage',
      //   checked: true,
      // },
      
    ],
  },
  */
  {
    id: 400,
    title: '예산 관리',
    icon: 'budget',
    expand: true,
    checked: true,
    items: [
      {
        id: 401,
        title: '연간 예산 수립',
        link: 'establish/budget',
        admin: true,
        checked: true,
      },
      {
        id: 402,
        title: '판매관리비 등록',
        link: 'sales-mng-cost-stats-new',        
        admin: true,
        checked: true,
      },
      
      /*
      {
        id: 101,
        title: '개인별 급여 입력',
        link: 'individual-salary-input',
        checked: true,
      },
      {
        id: 102,
        title: '개인별 직접비 예산',
        link: 'individual-directcost-budget',
        checked: true,
      },
      {
        id: 103,
        title: '전체 간접비 예산 입력',
        link: 'total-overhead-budget-input',
        checked: true,
      },
      {
        id: 104,
        title: '본부별 예산 입력',
        link: 'headquarter-budget-input',
        checked: true,
      },
      {
        id: 105,
        title: '팀별 예산 입력 ',
        link: 'team-budget-input',
        checked: true,
      },
      */
    ],
  },
  // {
  //   id: 9,
  //   title: '통계',
  //   link: 'statics',
  //   icon: 'statistics',
  //   items: [
  //     { id: 91, title: '기술통계(미구현)', link: 'techstat', checked: true },
  //   ],
  // },
  /*
  {
    id: 11,
    title: '제품관리',
    link: 'productmng',
    icon: 'product',
    expand: true,
    checked: true,
    items: [
      
      { id: 102, title: '재고관리', link: 'inventorymng', checked: true },
    ],
  },
  */

  {
    id: 1,
    title: '인사관리',
    link: 'employeemng',
    icon: 'user',
    expand: true,
    admin: true,
    items: [
      { id: 11, title: '사원관리', link: 'employeemng', checked: true },
      //  { id: 12, title: '계열사관리(미구현)', link: '', checked: false },
      { id: 12, title: '부서관리', link: 'deptmng', checked: true },
      // { id: 14, title: '휴가관리(미구현)', link: '', checked: false },
      //  { id: 15, title: '근태관리(미구현)', link: '', checked: false },
    ],
  },
  {
    id: 300,
    title: '총무관리',
    link: 'carmng',
    icon: 'partner',
    expand: true,
    checked: true,
    items: [
      { id: 301, title: '차량 관리', link: 'carasset', checked: true },
      { id: 302, title: '차량 운행 기록', link: 'carusage', checked: true },
      { id: 303, title: '차량 예약 현황', link: 'carusage/reservUsage', checked: true },
      //      { id: 93, title: '마감관리(미구현)', link: '', checked: true },
    ],
  },
  {
    id: 13,
    title: '공통관리',
    link: 'common',
    icon: 'common',
    expand: true,
    checked: true,
    admin: true,
    items: [
      { id: 131, title: '공통코드관리', link: 'codemng', checked: true },
      { id: 132, title: '권한별 메뉴관리', link: 'authmenumng', checked: true },
      { id: 133, title: '사원별 메뉴관리', link: 'usermenumng', checked: true },
      /* {} id: 134, title: '스케줄 관리', link: 'schedulemng', checked: true} ,*/
      { id: 135, title: '공지사항 관리', link: 'noticemng', checked: true },
    ],
  },
];
